import { AgXToneMapping, Color, ColorManagement, WebGLRenderer } from 'three';

// import { DEBUG } from '@scripts/Config/Global.js';
import { lisa } from './Lisa.js';

class Renderer extends WebGLRenderer {
	constructor() {
		super({ antialias: true, powerPreference: 'high-performance' });
		lisa.state.register(this);

		ColorManagement.enabled = true;
		this.autoClear = false;
		// this.debug.checkShaderErrors = DEBUG;
		this.setClearColor(new Color(0xffffff), 0);
		this.toneMapping = AgXToneMapping;
	}

	onResize({ width, height, dpr }) {
		this.setSize(width, height);
		this.setPixelRatio(dpr);
	}
}

export { Renderer };
